import { Injectable } from "@angular/core";

import { Observable, catchError } from "rxjs";

import { ApiTemplate } from "../base/template/api.template";
import { RequestOptions, ApiResponse, TemplateHelper } from "../base";
import { ProfileReference } from "./model/profile.model";
import { Person, User, UserInfo, UserRequest } from "./model/user.model";

@Injectable({ providedIn: 'root' })
export class UserApi extends ApiTemplate<User, UserRequest> {
    constructor() {
        super('http.rest.identity.url', "/api/users");
    }

    getExtended(userId: number, options?: RequestOptions): Observable<ApiResponse<UserInfo>> {
        const url = this.urlBuilder!.build(`${userId}/extended`);
        const httpOptions = TemplateHelper.buildOptions(options);

        return this.http
            .get<ApiResponse<UserInfo>>(url, httpOptions)
            .pipe(
                TemplateHelper.applyRetry(options),
                catchError((err) => TemplateHelper.handleError(err))
            );
    }

    updateProfiles(
        userId: number,
        profiles: readonly UserProfileIdPayload[],
        options?: RequestOptions,
    ): Observable<ApiResponse<User>> {
        const url = this.urlBuilder!.build(`${userId}/profiles`);
        const httpOptions = TemplateHelper.buildOptions(options);

        return this.http
            .put<ApiResponse<User>>(url, profiles, httpOptions)
            .pipe(
                TemplateHelper.applyRetry(options),
                catchError((err) => TemplateHelper.handleError(err))
            );
    }
}

export interface UserProfileIdPayload extends ProfileReference {
    id: number;
}
